import { render, staticRenderFns } from "./Quotation.vue?vue&type=template&id=68a5aa04&scoped=true&"
import script from "./Quotation.vue?vue&type=script&lang=js&"
export * from "./Quotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a5aa04",
  null
  
)

export default component.exports